import { APIuuid, IAPIData } from '@shared/interfaces/api.interface';
import { IIntegrationsSalesforce } from '@shared/interfaces/integrations/integrations.salesforce.interface';

export class IntegrationsSalesforce implements IIntegrationsSalesforce {
  public static readonly TYPE: string = String(
    'ExternalAuthorisations::Salesforce'
  );

  public id: APIuuid;
  public site_url: string;
  public client_id: string;
  public client_secret: string;
  public username: string;
  public password: string;

  public get apiData(): IAPIData {
    return {
      data: {
        type: IntegrationsSalesforce.TYPE,
        id: this.id,
        attributes: {
          site_url: this.site_url,
          client_id: this.client_id,
          client_secret: this.client_secret,
          username: this.username,
          password: this.password
        }
      }
    } as IAPIData;
  }

  constructor(partial: Partial<IIntegrationsSalesforce>) {
    Object.assign(this, partial);
  }

  public static fromAPI(res: IAPIData): IntegrationsSalesforce {
    const data = res.data;
    const types = [IntegrationsSalesforce.TYPE, 'ExternalAuthorisation'];

    if (!types.includes(data?.type)) {
      throw new Error(
        `There was a problem parsing ${IntegrationsSalesforce.TYPE} API data`
      );
    }

    return new IntegrationsSalesforce({
      id: data.id,
      ...data.attributes
    });
  }
}
